// VotarEmpresaInspiradoraExternoPage.tsx
import { Group, Loader, Text } from "@mantine/core";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Wizard from "@/modules/votar-empresa-inspiradora/components/PaginaInicial";
import useGetQuestionarioItem from "@/modules/votar-empresa-inspiradora/hooks/useGetQuestionarioFromUrl";

export type Parameters_ = {
  licenciadaId: string;
  empresaId: string;
  questionarioId: string;
};

const VotarEmpresaInspiradoraExternoPage = () => {
  const { empresaId, questionarioId } = useParams<Parameters_>();
  const [loading, setLoading] = useState(true);
  const { data: questionario, isLoading } = useGetQuestionarioItem(empresaId || "", questionarioId || "");

  useEffect(() => {
    if (!isLoading) {
      setLoading(false);
    }
  }, [isLoading]);

  if (loading) {
    return (
      <Group justify="center" align="center" style={{ height: "100vh" }}>
        <Text fw="bold" c="blue">
          Buscando questionário...
        </Text>
        <Loader size="xs" />
      </Group>
    );
  }

  if (!empresaId) {
    return (
      <Group justify="center" align="center" style={{ height: "100vh" }}>
        <Text fw="bold" c="red">
          Empresa não encontrada!
        </Text>
      </Group>
    );
  }
  const now = new Date();
  const endDate = new Date("2025-08-20T18:00:00-03:00");
  if (now > endDate) {
    return (
      <Group justify="center" align="center" style={{ height: "100vh" }}>
        <Text fw="bold" c="red">
          Votação encerrada! Agradecemos sua participação.
        </Text>
      </Group>
    );
  }
  if (!questionario) {
    return (
      <Group justify="center" align="center" style={{ height: "100vh" }}>
        <Text fw="bold" c="blue">
          Carregando votação...
        </Text>
      </Group>
    );
  }

  return (
    <Group>
      <Wizard />
    </Group>
  );
};

export default VotarEmpresaInspiradoraExternoPage;
